// A helper utility to determine if the app is running in Chromatic or storybook.
// This is useful for changing the behavior of components when running in Chromatic.
// (e.g. disabling animations, etc.)
function getIsRunningInChromatic() {
    // We're using own custom global variable here because the `isChromatic` check is
    // provided by Chromatic's NPM package and we don't want to import it in the portal-shell.
    // This flag is set in our storybook preview script - packages/portal-shell/.storybook/preview.ts
    return globalThis['__isRunningInChromatic'] || false;
}
function getIsRunningInStorybook() {
    return globalThis['__isStorybook'] || false;
}

export { getIsRunningInChromatic as a, getIsRunningInStorybook as g };

//# sourceMappingURL=chromatic-b6cfde84.js.map